import { render } from "./MyInfo.vue?vue&type=template&id=527d2ea1&ts=true"
import script from "./MyInfo.vue?vue&type=script&lang=ts"
export * from "./MyInfo.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__